// src/views/EjecucionesManuales/ImportacionSap/ImportacionSap.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function ImportacionSap() {
  return (
    <EjecutarProceso
      procesoId={7}
      titulo="Importación SAP"
      showSuccess={true}   // ✅ SOLO OK
    />
  );
}
